import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step2({ data, onChange, onNext, onBack }) {

  const isValid =
    data.parentesco &&
    data.escolaridade &&
    data.pessoasResidencia &&
    data.criancasResidencia;

  return (
    <>
    <SectionCard
          title="Identificação do Responsável"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
  name="parentesco"
  title="O que você é do aluno?"
  subtitle="(Resposta única)"
  options={[
    "Mãe / Pai",
    "Irmão / Irmã",
    "Avó / Avô",
    "Tio / Tia"
  ]}
  selected={data.parentesco}
  onSelect={(value) => onChange({ parentesco: value })}
/>

<QuestionBlock
  name="escolaridade"
  title="Qual é o seu nível de escolaridade atual?"
  subtitle="(Resposta única)"
  options={[
    "Não estudei",
    "Ensino Fundamental",
    "Ensino Médio",
    "Ensino Superior"
  ]}
  selected={data.escolaridade}
  onSelect={(value) => onChange({ escolaridade: value })}
/>

<QuestionBlock
  name="pessoasResidencia"
  title="Quantas pessoas moram na sua residência?"
  subtitle="(Resposta única)"
  options={[
    "2 a 3 pessoas",
    "4 a 5 pessoas",
    "6 a 7 pessoas",
    "Mais de 7 pessoas"
  ]}
  selected={data.pessoasResidencia}
  onSelect={(value) => onChange({ pessoasResidencia: value })}
/>

<QuestionBlock
  name="criancasResidencia"
  title="Quantas crianças moram na sua residência?"
  subtitle="(Resposta única)"
  options={[
    "1 a 2 crianças",
    "3 a 4 crianças",
    "5 a 6 crianças",
    "Mais de 6 crianças"
  ]}
  selected={data.criancasResidencia}
  onSelect={(value) => onChange({ criancasResidencia: value })}
/>
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
